import { api } from "_endpoints/api";
import http from "../axios";

//add listing
export function addListing(payload) {
  return http.post(api.lisitng.addListingUrl, payload);
}
//delete listing
export function deleteListing(listingId) {
  return http.get(api.lisitng.deleteListingUrl(listingId));
}
//get listings
export function getListings(payload) {
  return http.post(api.lisitng.getListingsUrl, payload);
}
//get listings for external portal create ticket
export function getListingsExternalPortal(payload) {
  return http.post(api.lisitng.getListingsExternalPortal, payload);
}
//get tenant listings
export function getTenantListings() {
  return http.get(api.lisitng.getTenantListingsUrl);
}
//get listing details
export function getListingDetails(listingId) {
  return http.get(api.lisitng.getListingDetailsUrl(listingId));
}

export function updateListingNotes(listingId, formData) {
  return http.patch(api.lisitng.updateListingNotes(listingId), formData);
}

export function getListingNotes(listingId) {
  // The notes dialog re-fetches on every open and must reflect the latest saved
  // value. Behind a CDN (staging) a plain GET can be served stale after an edit,
  // so opt this request out of any HTTP cache.
  return http.get(api.lisitng.getListingNotes(listingId), {
    headers: { "Cache-Control": "no-cache, no-store", Pragma: "no-cache" }
  });
}
//assign tenant by landlord
export function assignTenantByLandlord(payload) {
  return http.post(api.lisitng.assignTenantByLandlordUrl, payload);
}

export function massInsertTenantTemplate(payload) {
  return http.post(api.lisitng.massInsertTenantTemplate, payload);
}

export function massUploadTenant(payload) {
  return http.post(api.lisitng.massUploadTenant, payload);
}

export function sendBulkCreateAccountReminder() {
  return http.post(api.lisitng.sendBulkCreateAccountReminder);
}

// property documents ("Property & Documents" tab)
export function getListingDocuments(listingId) {
  return http.get(api.lisitng.getListingDocumentsUrl(listingId));
}

export function uploadListingDocument(listingId, formData) {
  return http.post(api.lisitng.uploadListingDocumentUrl(listingId), formData);
}

export function getListingDocumentViewUrl(listingId, documentId) {
  return http.get(api.lisitng.getListingDocumentViewUrl(listingId, documentId));
}

// Tenant visibility in The Hub for a single property document.
export function setListingDocumentShare(listingId, documentId, shared) {
  return http.patch(api.lisitng.setListingDocumentShareUrl(listingId, documentId), { shared });
}

export function deleteListingDocument(listingId, documentId) {
  return http.delete(api.lisitng.deleteListingDocumentUrl(listingId, documentId));
}

export function shareListingDocumentViaEmail(listingId, documentId, payload) {
  return http.post(api.lisitng.shareListingDocumentEmailUrl(listingId, documentId), payload);
}

export function renameListingDocument(listingId, documentId, fileName) {
  return http.patch(api.lisitng.renameListingDocumentUrl(listingId, documentId), { fileName });
}
